/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Plaintext_LabelInputs */

const en_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plain Text`)
};

const fr_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plain Text`)
};

const de_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klartext`)
};

const it_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo normale`)
};

const ru_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Простой текст`)
};

const es_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto sin formato`)
};

const zh_cn2_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯文本`)
};

const ja_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレーンテキスト`)
};

const hi_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सादे पाठ`)
};

const pt_pt2_file_import_plaintext_label = /** @type {(inputs: File_Import_Plaintext_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto simples`)
};

/**
* | output |
* | --- |
* | "Plain Text" |
*
* @param {File_Import_Plaintext_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_plaintext_label = /** @type {((inputs?: File_Import_Plaintext_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Plaintext_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_import_plaintext_label(inputs)
	if (locale === "de") return de_file_import_plaintext_label(inputs)
	if (locale === "it") return it_file_import_plaintext_label(inputs)
	if (locale === "ru") return ru_file_import_plaintext_label(inputs)
	if (locale === "es") return es_file_import_plaintext_label(inputs)
	if (locale === "zh-CN") return zh_cn2_file_import_plaintext_label(inputs)
	if (locale === "ja") return ja_file_import_plaintext_label(inputs)
	if (locale === "hi") return hi_file_import_plaintext_label(inputs)
	if (locale === "pt-PT") return pt_pt2_file_import_plaintext_label(inputs)
	return en_file_import_plaintext_label(inputs)
});